import { render, staticRenderFns } from "./DatosCompradorProductos.vue?vue&type=template&id=70d04918"
import script from "./DatosCompradorProductos.vue?vue&type=script&lang=js"
export * from "./DatosCompradorProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports